export var ACTIVITY_LIST_PATH = '/actions/';
